var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 14.25V12.75C0.75 11.9544 1.06607 11.1913 1.62868 10.6287C2.19129 10.0661 2.95435 9.75 3.75 9.75H6.75C7.54565 9.75 8.30871 10.0661 8.87132 10.6287C9.43393 11.1913 9.75 11.9544 9.75 12.75V14.25M10.5 0.8475C11.1453 1.01273 11.7173 1.38803 12.1257 1.91423C12.5342 2.44044 12.7559 3.08762 12.7559 3.75375C12.7559 4.41988 12.5342 5.06706 12.1257 5.59327C11.7173 6.11947 11.1453 6.49477 10.5 6.66M14.25 14.25V12.75C14.2462 12.0879 14.0234 11.4456 13.6165 10.9233C13.2095 10.401 12.6411 10.028 12 9.8625M2.25 3.75C2.25 4.54565 2.56607 5.30871 3.12868 5.87132C3.69129 6.43393 4.45435 6.75 5.25 6.75C6.04565 6.75 6.80871 6.43393 7.37132 5.87132C7.93393 5.30871 8.25 4.54565 8.25 3.75C8.25 2.95435 7.93393 2.19129 7.37132 1.62868C6.80871 1.06607 6.04565 0.75 5.25 0.75C4.45435 0.75 3.69129 1.06607 3.12868 1.62868C2.56607 2.19129 2.25 2.95435 2.25 3.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c3bdd48676c61117eb25b7c61013894d.svg";
export { ForwardRef as ReactComponent };